import { useState } from "react";
import moment from "moment";
import { MDBRow } from "mdb-react-ui-kit";
import { Icon } from "@iconify/react";

//primereact
import { InputSwitch } from "primereact/inputswitch";
import { Calendar } from "primereact/calendar";

//component
import ListingTable from "../../../components/modal/listingTable";
import Dropdown from "../../../components/element/dropdown";
import ButtonToggle from "../../../components/element/toggleButton";
import apiServices from "../../../services/api.services";
import ToggleSwitch from "../../../components/element/toggleSwitch";

export default function Setting({
  length,
  start,
  createAble,
  listingData,
  totalRecords,
  displayRecords,
  setSearch,
  setStartDate,
  setEndDate,
  setOrder,
  setLength,
  setStart,
  actionValue,
  handleActionChange,
  setHandleApplyFilter,
  getListing,
}) {
  const actionOptions = ["information"];
  const [date, setDate] = useState(new Date());

  const handleChange = async (userId) => {
    try {
      const response = await apiServices.userStatusToggle({ userId });
      if (response == 200) {
        getListing();
      }
    } catch (ex) {}
  };

  const statusBodyTemplate = (options) => {
    return (
      <InputSwitch
        checked={options.status}
        trueValue="Active"
        falseValue="Inactive"
        onChange={(e) => handleChange(options.id)}
      />
    );
  };

  const phoneBodyTemplate = ({ phone }) => {
    if (phone) {
      return (
        <span>
          {phone.countryCode}
          {phone.phoneNumber}
        </span>
      );
    }
  };

  const dateBodyTemplate = ({ lastLoginedAt }) => {
    if (lastLoginedAt) {
      return <span>{moment(lastLoginedAt).format("DD/MM/YYYY")}</span>;
    }
  };

  const actionBodyTemplate = (options, { rowIndex }) => {
    return (
      <MDBRow className="action-button">
        <div
          style={{ width: "auto" }}
          onClick={() => handleActionChange("information", options)}
        >
          <Icon
            icon="heroicons:clipboard-document-list"
            color="#41B1CD"
            width="25"
            height="25"
          />
        </div>
      </MDBRow>
    );
  };

  // inline edit complete function //
  const onRowEditComplete = async (e) => {
    const payload = {
      type: e.newData.type,
      name: e.newData.name,
      original_price: e.newData.original_price,
      current_price: e.newData.current_price,
      method: "PUT",
    };
    try {
      const response = await apiServices.updateInfo({
        api_name: "room_update",
        id: e.newData.id,
        payload: payload,
      });
      if (response) {
        getListing();
      }
    } catch (ex) {}
  };

  const filterDateTemplate = (options) => {
    return (
      <Calendar
        id="range"
        value={date}
        onChange={(e) => {
          setDate(e.value);
          setStartDate(e.value[0]);
          setEndDate(e.value[1]);
          // options.filterCallback(e.value);
        }}
        selectionMode="range"
        readOnlyInput
        showIcon
      />
    );
  };

  const monthlyCheckInBodyTemplate = (options) => {
    return <InputSwitch checked={options.monthly_check_in} disabled />;
  };

  const columns = [
    { selectionMode: "multiple", headerStyle: "3em" },
    { field: "name", header: "Name", editor: true },
    { field: "description", header: "Description", editor: true },
    { field: "type", header: "Type", editor: true },
    {
      field: "current_price",
      header: "Current Price",
      editor: true,
      headerStyle: "2em",
    },
    {
      field: "original_price",
      header: "Original Price",
      editor: true,
      headerStyle: "2em",
    },
    // {
    //   field: "created_at",
    //   header: "Register Date",
    //   filterElement: filterDateTemplate,
    // },
    {
      field: "status",
      header: "Status",
      body: statusBodyTemplate,
    },
    // { field: "", body: actionBodyTemplate, headerStyle: "0.5em"},
    { field: "", rowEditor: true, headerStyle: "1em" },
  ];

  const sortFunction = (event) => {
    const field = event.field.split(".")[0];
  };

  return (
    <div className="listing-container">
      <ListingTable
        title="Agent Setting"
        data={listingData}
        columns={columns}
        createAble={createAble}
        setSearchValue={setSearch}
        setHandleApplyFilter={setHandleApplyFilter}
        setOrder={setOrder}
        length={length}
        start={start}
        setLength={setLength}
        setStart={setStart}
        totalRecords={totalRecords}
        displayRecords={displayRecords}
        onRowEditComplete={onRowEditComplete}
      />
    </div>
  );
}
